<div class="page-register flex flex-row">
    <div class="left-part w-2/5 flex flex-col justify-between">
        <img class="w-full h-2/3" src="../../../assets/img/login.svg" alt="">
        <div class="left-word text-base font-medium lineheight-150">Unlock
            <span class="left-word-bold"> effortless shopping</span>
            at your own pace
        </div>
    </div>

    <div class="right-part w-3/5 flex flex-col">
        <amm-register-step [step]="step" (onClose)="onCloseEvent($event)"></amm-register-step>
    </div>
</div>
